import "./help.md";
import "../info-page.ts";
import "../../features/help/HotkeyViewerElement";
import "../../features/help/GestureViewerElement";